import React from 'react'
import { connect as connectRedux } from 'react-redux'
import { List, Map } from 'immutable'
import { getBoundActions } from '../../../actions/index'
import { formatDuration } from '../../../theme/web-app/index'
import {
  getFormattedContentData,
  CONTENT_IMAGE_TYPE_KEYART_WITH_TEXT,
} from '../../../services/content/index'
import { PLAY_CLICK_GA4_EVENT } from '../../../services/event-tracking/index'
import Picture, { IMAGE_TYPE_WEBP, IMAGE_LOADING_LAZY } from '../../Picture/index'
import ProgressBar from '../../ProgressBar/index'
import Link from '../../Link/index'
import { getOptimizedImageUrl } from '../utils'

/**
 * Course detail page practices tiles tab component
 * @param {Object} props - The props
 * @param {List} props.practicesData - The practices data
 * @returns {JSX.Element} DetailPageV3CoursePracticeItem
 */

function DetailPageV3CoursePracticeItem (props) {
  const {
    itemData = Map(),
    setEventDefault,
  } = props

  const tileData = getFormattedContentData(itemData)
  const isAllowed = tileData.getIn(['featureMedia', 'contentPolicy', 'accessCheck', 'allowed'])
  const duration = tileData.getIn(['featureMedia', 'duration'], 0) || 0
  const userMediaPosition = tileData.getIn(['featureMedia', 'userMediaPosition', 'position'], 0) || 0
  const hasProgressBar = userMediaPosition > 0
  const image = tileData.get('images', List()).find((i) => i.get('type') === CONTENT_IMAGE_TYPE_KEYART_WITH_TEXT) || Map()
  const { fallbackImageUrl, imageUrl } = getOptimizedImageUrl(image.get('url'), '320')

  const ga4EventData = {
    content_name: tileData.get('title'),
    content_id: tileData.get('contentId'),
    content_type: tileData.get('contentType'),
    media_id: tileData.getIn(['featureMedia', 'mediaId']),
    media_language: tileData.get('languageFullText'),
    parent_series_id: tileData.get('seriesId'),
    parent_series_name: tileData.get('seriesTitle'),
    is_featured_media: true,
    ui_location: 'Course page',
    ui_element: 'Tile',
  }

  const handleLinkClick = () => {
    // GA4 events
    setEventDefault(PLAY_CLICK_GA4_EVENT.mergeDeep(ga4EventData))
  }

  return (
    <div className="detail-page-v3__course-practice-item">
      <div className="detail-page-v3__course-practice-item-container">
        <div className="detail-page-v3__course-practice-item-image">
          <Link
            to={tileData.get('path')}
            query={isAllowed ? { fullplayer: 'feature' } : undefined}
            onClick={handleLinkClick}
          >
            <Picture
              fallbackSrc={fallbackImageUrl}
              alt={tileData.get('title')}
              loading={IMAGE_LOADING_LAZY}
              sources={[
                {
                  type: IMAGE_TYPE_WEBP,
                  srcSet: imageUrl,
                },
              ]}
            />
            {hasProgressBar && (
              <div className="detail-page-v3__course-practice-item-progress-bar">
                <ProgressBar
                  duration={duration}
                  userInfo={Map({ featurePosition: userMediaPosition })}
                />
              </div>
            )}
          </Link>
        </div>
        <div className="detail-page-v3__course-practice-item-details">
          <Link
            to={tileData.get('path')}
            query={isAllowed ? { fullplayer: 'feature' } : undefined}
            onClick={handleLinkClick}
          >
            <h5 className="detail-page-v3__course-practice-item-title">
              {tileData.get('title')}
            </h5>
          </Link>
          <p className="detail-page-v3__course-practice-item-duration">
            {formatDuration(duration)}
          </p>
        </div>
      </div>
    </div>
  )
}

export default connectRedux((state) => ({
  upstreamContext: state.upstreamContext,
}), (dispatch) => {
  const actions = getBoundActions(dispatch)
  return {
    setEventDefault: actions.eventTracking.setEventDefault,
  }
})(DetailPageV3CoursePracticeItem)
